var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftPanelOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02507 11.6411V4.25893L8.00007 7.95L4.02507 11.6411ZM14.3648 15.9C14.8007 15.9 15.1739 15.7448 15.4844 15.4343C15.7949 15.1239 15.9501 14.7507 15.9501 14.3147V1.58527C15.9501 1.14931 15.7949 0.776112 15.4844 0.465667C15.1739 0.155223 14.8007 0 14.3648 0H1.63534C1.19938 0 0.826184 0.155223 0.515739 0.465667C0.205296 0.776112 0.0500736 1.14931 0.0500736 1.58527V14.3147C0.0500736 14.7507 0.205296 15.1239 0.515739 15.4343C0.826184 15.7448 1.19938 15.9 1.63534 15.9H14.3648ZM11.4072 14.1964V1.70357H14.2465V14.1964H11.4072ZM9.70364 14.1964H1.75364V1.70357H9.70364V14.1964Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelOpen);
export default __webpack_public_path__ + "static/media/left_panel_open.392ce4e131b89525ff06dacfa6c7b15b.svg";
export { ForwardRef as ReactComponent };